import { BaseSecurityTextBoxComponent } from '../base/base-security-text-box/base-security-text-box.component';
import { ElementRef, ChangeDetectionStrategy, Component, Input, ViewChild, OnInit, OnChanges, OnDestroy, ChangeDetectorRef, SimpleChanges, AfterViewInit, EventEmitter, Output, NgZone, Renderer2 } from '@angular/core';
import { NewBasePropertyTextBox } from '../new-base-property-text-box';
import { MobileHelper, PopperHelper } from '@nts/std/utility';
import { NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers } from 'ngx-popperjs';
import { Meta } from '@angular/platform-browser';
import { AsyncPipe, NgIf } from '@angular/common';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FilePropertyViewModel } from '../../../../view-models/base-type/file-property-view-model';
import { BaseFileUploadBoxComponent } from '../base/base-file-upload-box/base-file-upload-box.component';

@UntilDestroy()
@Component({
    selector: 'nts-file-text-box',
    templateUrl: './file-text-box.component.html',
    styleUrls: ['./file-text-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgxPopperjsModule,
        BaseSecurityTextBoxComponent,
        BaseFileUploadBoxComponent,
        AsyncPipe
    ]
})
export class FileTextBoxComponent extends NewBasePropertyTextBox<string> implements OnInit, OnChanges, OnChanges, AfterViewInit, OnDestroy {
    
    @Input() override initialValue: string;
    
    @Input() selectAllOnFocus = true;
    @Input() showErrorTooltip = true;
    @Input() showErrorBorder = true;
    @Input() listenClickOutside = false

    /**
     * Update model at blur
     */
    @Input() override updateOnBlur = true;

    /**
     * Update model at focus out
     */
    @Input() override updateOnFocusOut = true;

    @Output() onFinishEditing = new EventEmitter();

    @ViewChild('baseSecurityTextBox', { static: false }) baseSecurityTextBox: BaseSecurityTextBoxComponent;
    @ViewChild('baseFileUploadBox', { static: false }) baseFileUploadBox: BaseFileUploadBoxComponent;

    override propertyViewModel: FilePropertyViewModel;
    element: ElementRef;
    ngxPopperjsTriggers = NgxPopperjsTriggers;
    ngxPopperjsPlacements = NgxPopperjsPlacements;

    constructor(
        private meta: Meta,
        cd: ChangeDetectorRef
    ) {
        super(cd);
    }
    ngOnDestroy(): void {
        MobileHelper.clearFixZoomIssue(this.input, this.meta);
    }

    ngOnInit() {
        if (!this.propertyViewModel) { throw new Error('Missing viewModel!'); }
        this.cd.detectChanges(); 
    }

    ngAfterViewInit(): void {
        if (this.baseFileUploadBox) {
            this.element = (this.propertyViewModel?.securityAccess == null ? this.baseFileUploadBox.inputFile : this.baseSecurityTextBox.securityTextBox);
        }

        super.init();
    }

    modelChange(e: File) {
        this.propertyViewModel.file$.next(e);
        this.updateModel();
    }

    untilDestroyedThis(): <U>(source: Observable<U>) => Observable<U> {
        return untilDestroyed<this>(this)
    }

    get input() {
        return this.baseFileUploadBox.inputFile.nativeElement;
    }

    get inputValue() {
        if (this.baseFileUploadBox?.files$?.value?.length > 0) {
            return this.baseFileUploadBox.files$.value[0].name;
        }
        return null;
    }

    selectAllContent($event: FocusEvent) {
        if (this.selectAllOnFocus) {
            setTimeout(() => {
                const tgt = ($event.target as HTMLInputElement);
                if (tgt === document.activeElement) {
                    ($event.target as HTMLInputElement).select();
                }
            }, 50);
        }
    }

    showErroTooltip(): void {
        if (this.baseFileUploadBox?.popperError) {
            PopperHelper.show(this.baseFileUploadBox.popperError);
        } else if (this.baseFileUploadBox?.popperError) {
            PopperHelper.show(this.baseFileUploadBox.popperError);
        }
    }
}
